export default __webpack_public_path__ + "static/mouse-7bae98204ee4f7917acc4156ef8944a3.svg";